import ExpensesSubCategoriesContainer from "./ExpensesSubCategoriesContainer";

export default ExpensesSubCategoriesContainer;
